import { Program } from "./program.model";
import { Exam } from "./exam.model";

/* User defined models */
export class Test {
  sessions: any[];
  eligibility: any;
  status?: string;
  program?: Program;
  exam?: Exam;
  cnatt: boolean;

  constructor(  
    sessions: any[],
    eligibility: any,
    status?: string,
    exam?: any,
    program?: any
  ) {
    this.exam = exam;
    this.sessions = sessions;
    this.eligibility = eligibility;
    this.status = status;
    this.program = program;
  }
}